










import MenuMixin from '@/mixins/menu-mixin';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { namespace, State } from 'vuex-class';
import Left from '../layout/left.vue';
const System = namespace('System');
@Component({
  components: { Left }
})
export default class Jobs extends mixins(MenuMixin) {
  @State MENU_INDENT: any;
  menu: any = [
    { title: '作业调度管理', icon: 'fa-cubes', type: 'folder', oprate: false, expand: true, children: [] },
    { title: '作业运行管理', icon: 'fa-cubes', type: 'folder', oprate: false, expand: true, children: [] }
  ];

  created() {
    this.initMenu();
  }

  initMenu() {
    if (this.ROLE_MENU.length === 0) {
      setTimeout(() => {
        this.initMenu();
      }, 100);
    } else {
      this.MENU('JOB_SCH_ALL') && this.menu[0].children.push({ title: '作业调度总览', key: '/jobs/all', oprate: false, icon: 'fa-bar-chart' });
      this.MENU('RULE_JOB_SCH') && this.menu[0].children.push({ title: '决策分析作业', key: '/jobs/rule', oprate: false, icon: 'fa-calendar-o' });
      this.MENU('IND_JOB_SCH') && this.menu[0].children.push({ title: '指标固化作业', key: '/jobs/ind', oprate: false, icon: 'fa-calendar-o' });
      this.MENU('SUB_JOB_SCH') && this.menu[0].children.push({ title: '主题同步作业', key: '/jobs/sub', oprate: false, icon: 'fa-calendar-o' });
      this.MENU('DIM_JOB_SCH') && this.menu[0].children.push({ title: '维表同步作业', key: '/jobs/dim', oprate: false, icon: 'fa-calendar-o' });
      this.MENU('SYS_JOB_SCH') && this.menu[0].children.push({ title: '系统运维作业', key: '/jobs/sys', oprate: false, icon: 'fa-calendar-o' });
      this.MENU('MONITOR_JOB_SCH') && this.menu[0].children.push({ title: '财务监管作业', key: '/jobs/monitor', oprate: false, icon: 'fa-calendar-o' });
      this.MENU('DATA_JOB_SCH') && this.menu[0].children.push({ title: '数据管理作业', key: '/jobs/data', oprate: false, icon: 'fa-calendar-o' });
      this.MENU('JOB_REC_ALL') && this.menu[1].children.push({ title: '作业运行总览', key: '/jobs/record/total', oprate: false, icon: 'fa-bar-chart' });
      this.MENU('RULE_JOB_REC') && this.menu[1].children.push({ title: '决策分析作业', key: '/jobs/record/rule', oprate: false, icon: 'fa-calendar-check-o' });
      this.MENU('IND_JOB_REC') && this.menu[1].children.push({ title: '指标固化作业', key: '/jobs/record/ind', oprate: false, icon: 'fa-calendar-check-o' });
      this.MENU('SUB_JOB_REC') && this.menu[1].children.push({ title: '主题同步作业', key: '/jobs/record/sub', oprate: false, icon: 'fa-calendar-check-o' });
      this.MENU('DIM_JOB_REC') && this.menu[1].children.push({ title: '维表同步作业', key: '/jobs/record/dim', oprate: false, icon: 'fa-calendar-check-o' });
      this.MENU('SYS_JOB_REC') && this.menu[1].children.push({ title: '系统运维作业', key: '/jobs/record/sys', oprate: false, icon: 'fa-calendar-check-o' });
      this.MENU('MONITOR_JOB_REC') && this.menu[1].children.push({ title: '财务监管作业', key: '/jobs/record/monitor', oprate: false, icon: 'fa-calendar-check-o' });
      this.MENU('DATA_JOB_REC') && this.menu[1].children.push({ title: '数据管理作业', key: '/jobs/record/data', oprate: false, icon: 'fa-calendar-check-o' });
    }
  }

  @System.State activeTabs: any;
  @System.Mutation setActiveTabs: any;
  
  update(key: string) {
    if (/\/jobs/.test(key)) {
      let index = this.activeTabs.findIndex((v: any) => v.path.startsWith(key));
      if (index > -1) {
        this.setActiveTabs(this.activeTabs[index]);
        this.$router.push(this.activeTabs[index].fullPath);
      } else {
        this.$router.push(key);
      }
    }
  }
}
